export enum FormGroupNames {
  TestRequirements = 'testRequirements',
  TestResults = 'testResults',
  Samples = 'samples',
  TestMethodVariant = 'testMethodVariant',
  TestRequirement = 'testRequirement',
}
